module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/bucket-152f6f12ea0bb1c5816e21f9e9e00d3c.svg";